










import {Component, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class CommonSidebar extends Vue {

    public header = 'Services';
    public items = [

        {path: '/services/hair-and-makeup-services', text: 'Hair & Makeup'},
        {path: '/services/hair-services', text: 'Hair'},
        {path: '/services/makeup-services', text: 'Makeup'},
        {path: '/services/weddings', text: 'Weddings'},
        {text: 'Galas & Award Shows', path: '/services/events'},
        {text: 'TV & Film', path: '/services/tv-and-film'},
        {text: 'Beauty Packages', path: '/packages'},
        {text: 'Gift Cards', path: '/gift-cards'},
    ];
    public citiesHeader = 'Cities We Currently Service';
    public cities = [
        {path: '/locations/new-york-city', text: 'New York City Metro Area'},
        {path: '/locations/new-jersey-metro-area', text: 'New Jersey Metro Area'},
        {path: '/locations/los-angeles-metro-area', text: 'Los Angeles Metro Area'},
        {path: '/locations/las-vegas', text: 'Las Vegas Metro Area'},
        {path: '/locations/salt-lake-city', text: 'Salt Lake City Metro Area'},
        {path: '/locations/chicago', text: 'Chicago Metro Area'},

    ];

}
